import { ChevronUp } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChevronUpIcon = createLucideIcon(ChevronUp);
